var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01Linkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,0H0.8C0.4,0,0,0.4,0,0.8v5.8c0,0.5,0.4,0.8,0.8,0.8h5.8c0.5,0,0.8-0.4,0.8-0.8V0.8C7.5,0.4,7.1,0,6.7,0z  M2.5,5.8H1.4V2.9h1.1V5.8z M2,2.4c-0.3,0-0.5-0.2-0.5-0.5S1.6,1.4,2,1.4c0.3,0,0.5,0.2,0.5,0.5S2.3,2.4,2,2.4z M6.2,5.8h-1V4.2 c0-0.4-0.3-0.5-0.4-0.5S4.4,3.8,4.4,4.2c0,0.1,0,1.6,0,1.6H3.4V2.9h1.1v0.4c0.1-0.2,0.4-0.4,0.9-0.4s0.9,0.4,0.9,1.3V5.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Linkedin);
export default __webpack_public_path__ + "static/media/01-linkedin.939469a330568b389c1b1338d9fa8308.svg";
export { ForwardRef as ReactComponent };